import React, { useReducer } from 'react';
import { Route } from 'react-router-dom';
import SwitchRouter from 'components/SwitchRouter';
import { Dashboard } from './conferencia-cupons/Dashboard';
import { Details } from './conferencia-cupons/Details';
import { ConfCuponsStateContext, ConfCuponsDispatchContext, initialState } from './conferencia-cupons/ConfCuponsContext';

const reducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_PROFILE':
            return { ...state, profile: action.payload };

        case 'UPDATE_PROFILE_STATUS':
            return { ...state, active: action.payload };

        default:
            return state;
    }
};

export default function Routes({ match: { path } }) {

    const [state, dispatch] = useReducer(reducer, initialState);
    
    const routes = [
        { path: `${path}/conferencia-de-cupons`, exact: true, component: Dashboard },
        { path: `${path}/conferencia-de-cupons/detalhes`, exact: true, component: Details },
    ];

    return (
        <ConfCuponsStateContext.Provider value={state}>
            <ConfCuponsDispatchContext.Provider value={dispatch}>
                <SwitchRouter>
                    {routes.map((props, i) => (
                        <Route key={i} {...props} />
                    ))}
                </SwitchRouter>
            </ConfCuponsDispatchContext.Provider>
        </ConfCuponsStateContext.Provider>
    );
}
